import React, { useState } from "react";
import { Link } from "react-router-dom";
import MegaMenu from "./mega-menu/MegaMenu";
import MegaMenuMobile from "./mega-menu/MegaMenuMobile";

const HeaderDemo = () => {
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 68) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <>
      <div
        className={
          navbar
            ? "theme-main-menu sticky-menu theme-menu-one bg-none  fixed"
            : "theme-main-menu sticky-menu theme-menu-one bg-none"
        }
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="logo">
            <Link to="/">
              <img src="/images/logo/deski_06.svg" alt="brand logo" />
            </Link>
          </div>
          {/* End Logo */}

          <nav id="mega-menu-holder" className="navbar navbar-expand-lg">
            <div className="container nav-container">
              <div
                className="navbar-collapse collapse"
                id="navbarSupportedContent"
              >
                <div className="d-lg-flex align-items-center">
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown position-static active">
                      <a className="nav-link" href="/demo/ekyc" data-toggle="dropdown">
                      eKYC
                      </a>
                      
                      {/* /.dropdown-menu */}
                    </li>
                    {/* End li */}

                    <li className="nav-item dropdown">
                      <a className="nav-link" href="/demo/fake" data-toggle="dropdown">
                        Phát hiện giả mạo
                      </a>
                      {/* /.dropdown-menu */}
                    </li>
                    {/* End li */}

                    <li className="nav-item dropdown">
                      <a className="nav-link" href="/demo/ocr" data-toggle="dropdown">
                        Nhận dạng ký tự
                      </a>

                      {/* /.dropdown-menu */}
                    </li>
                    {/* End li */}

                    <li className="nav-item dropdown">
                      <a className="nav-link" href="/demo/oldphoto" data-toggle="dropdown">
                        Khôi phục ảnh cũ
                      </a>
                      {/* /.dropdown-menu */}
                    </li>
                    {/* End li */}

                    {/* End li */}
                  </ul>

                  <ul className="right-button-group d-flex align-items-center justify-content-center">
                     <li>
                      <a href="https://console.ekyc.solutions/" className="signIn-action">
                      Đăng nhập
                      </a>
                    </li>
                    
                  </ul>
                  {/* End right-button-group  */}
                </div>
              </div>
            </div>
          </nav>
          {/* End nav */}
        </div>

        <MegaMenuMobile />
        {/* 	End Mega Menu for Mobile */}
      </div>
      {/* /.theme-main-menu */}
    </>
  );
};

export default HeaderDemo;
